import { DriverStep } from '../types/DriverStep'

export const importTourSteps: DriverStep[] = [
  {
    element: '#order-import-form',
    popover: {
      title: 'Order Import Form',
      description: 'Import orders from an excel file. Select the import target and upload the file.',
    },
  },
  {
    element: '#import-target-radio-button',
    popover: {
      title: 'Import Target',
      description: 'Import orders to the inbox, an existing scenario, or create a new scenario for a specific date or day of the week.',
    },
  },
  {
    element: '#import-order-file',
    popover: {
      title: 'Order Excel File',
      description: 'Click to select the order excel file to upload, or drag the file to this area.',
    },
  },
  {
    element: '#primary-nav-operations',
    popover: {
      title: 'That\'s it!',
      description: 'Once the import is complete, your orders will appear in your selected destination. Proceed to the Operations page to start planning your deliveries.',
    },
  },

]